// src/LEDRing.js
import React from "react";
import "./LEDRing.css";

const LEDRing = ({ isSpinning = false }) => {
  const ledCount = 36;
  const leds = Array.from({ length: ledCount }, (_, i) => i);

  return (

    <>
          <div className="glow-ring"></div>

    <div className={`led-ring ${isSpinning ? 'spinning' : ''}`}>
      {leds.map((index) => (
        <div
          key={index}
          className="led-dot"
          style={{
            '--i': index,
            '--count': ledCount,
          }}
        />
      ))}
    </div>
    </>
  );
};

export default LEDRing;